const hydrateCustomHeader = () => {
    const headerSidebarOpenBtn = document.getElementById("header-sidebar-open")
    const headerSidebarCloseBtn = document.getElementById("header-sidebar-close")

    const tween = gsap.fromTo(".custom-header-sidebar", {
        transform: "translate(100%, 0)"
    }, {
        transform: "translate(0%, 0)",
        ease: "power2.inOut",
        duration: 0.3,
        paused: true
    })

    headerSidebarOpenBtn.addEventListener("click", () => {
        document.body.style.overflow = "hidden";
        tween.play();
    })
    headerSidebarCloseBtn.addEventListener("click", () => {
        document.body.style.removeProperty("overflow");
        tween.reverse();
    })
}

hydrateCustomHeader()
document.addEventListener("shopify:section:load", hydrateCustomHeader);